<template>
        <div class="buy_detail">
          <!-- <p class="title" style="margin:0">一、数据列表</p> -->
          
          <table class="buytable">
            <thead>
              <tr>
                <td width="130px" style="text-align:center">类别</td>
                <td width="270px">明细</td>
                <td style="text-align:center">说明</td>
                <!-- <td width="100px">10E基础版</td> -->
                <td width="100px" style="color:white;text-align:center">11C标准版</td>
              </tr>
            </thead>
            <tbody v-for="(item,index) in  list1" :key="index">
                <tr v-for="(item1,index1) in item.Children" :key="index1">
                  <td v-if="index1==0" :rowspan="item.Children.length" style="text-align:center">{{item.IssueName.includes('收费')?item.IssueName.slice(0,-4):item.IssueName}}</td>
                  <td class="tdstyle1">{{item1.IssueName.split('-')[0]}}</td>
                  <td :rowspan="item.Children.length" v-if="index1==0&&index!=2">{{item.texts}}</td>
                  <td v-if="index==2" style="text-align:left;padding:8px 10px">{{item.texts[index1]}}</td>
                  <!-- <td :rowspan="item.Children.length"  v-if="index1==0"> {{index==list1.length-1?'':'√'}}</td> -->
                  <td :rowspan="item.Children.length"  v-if="index1==0">√</td>
                </tr>
            </tbody>
            <tbody>
              <tr>
                  <td colspan="3" style="text-align:right">数据服务费（元/年/账号）</td>
                  <!-- <td  style="color: #287cee;padding:10px 0;border-left: none;text-align:center;padding-right:0"> <span style="font-weight: bold;font-size: 18px;">1200</span><br><span @click="checktel(125)" style="cursor:pointer;text-decoration: underline;">去购买</span></td> -->
                  <td style="color: #287cee;text-align:center;padding-right:0"> <span style="font-weight: bold;font-size: 18px;">{{Price(webMarketPrice.price1)}}</span><br> <span @click="checktel(138)" style="cursor:pointer;text-decoration: underline;">去购买</span> </td>
              </tr>
            </tbody>
          </table>
            <div style="margin-top:8px;font-size:14px;color:#6f6f6f">软件提供133个开源因子，就是引用上表的数据函数编写的，涵盖量价类、财务类、盈利预测类、市场估值类、持股结构类，以及可转债相关的因子。</div>
            <div>
            <div style="height:90px;margin-top: 65px;">
              <div style="float:left;margin-top:22px;font-size:14px;" class="buy_tel">咨询电话：<common-data name="serviceTel"/></div>
            </div>
          </div>
           <cont
                v-if="showcont"
                :txt="showcont"
                v-on:txt="close($event)"
                :tt="tt"
            ></cont>
            <VerifyTel v-if="showVerifyTel" :src="src" @close="closeVerifyTel" @check="checkVerifyTel" :text="text"></VerifyTel>
            <Pay v-if="showPay" :src="wh11Url" @close="closePay" ></Pay>
        </div>
</template>

<script>
import cont from "./cont.vue";
import axios from "axios";
import Pay from './Pay.vue'
import VerifyTel from './VerifyTel.vue';
import dict from '../assets/js/dict.json'
import commonData from '../plugins/FetchCommonData'
export default {
  data() {
    return {
      showcont: false,
      sf: "- 省份 -",
      cs: "- 城市 -",
      sfli: [],
      csfi: [],
      ind: "",
      ifla: false,
      iflacs: false,
      tt: "",
      yuyueShow: false,
      list1:[],
      txt1:[
        '提供沪深股票、可转债、指数、期货的日K线数据、停牌信息、交易日列表，以及股票、股票/可转债指数的常用技术指标数据。',
        '提供沪深股票的基本面数据、财务数据、资金流向、股东信息、分析师预期等数据，以及可转债的基本资料、衍生指标等以及强赎、回售、下修等条款信息。',
        ['提供GDP、PMI、M0/M1/M2、CPI、PPI等中国宏观经济数据。','提供中国国债收益率数据。'],
        '提供特色股票市场法估值数据、事件驱动数据、日内统计数据。',
      ],
      showVerifyTel:false,
      showPay:false,
      src:'webtq10',
      wh11Url:'https://pay.wenhua.com.cn/#/iframePay/138?from=starquant&validdata=',
      text:'',
      webMarketPrice:{
        price1:0,
      },
    };
  },
  components: {
    cont,VerifyTel,Pay
  },
  methods: {
    setPrice(){
        axios.get('https://pay.wenhua.com.cn/api/Product/Detail?id=138').then((res) => {
          if (res.data.status) {
            this.webMarketPrice.price1 = res.data.data.price            
          } else {
            alert(res.data.message)
          }
        });
    },
    Price(money){
      if(Number(money)>10000){
        return Math.floor(money/10000)+'万'
      }
      else{
        return money
      }
    },
    checkVerifyTel(data){
      this.wh11Url=this.wh11Url + data
      this.showVerifyTel=false
      this.showPay=true
    },
    closeVerifyTel(){
      this.showVerifyTel=false
    },
    closePay(message){
      if(message.data=='close'){
        this.showPay = false
      }
    },
    checktel(num){
      this.wh11Url= 'https://pay.wenhua.com.cn/#/iframePay/'+num+'?from=starquant&validdata='
      this.showVerifyTel=true
    },
    close(e) {
      this.showcont = e;
    },
    getdict(){
      this.list1=dict.Children
        console.log(this.list1)
        this.list1.forEach((el,idx)=>{
                this.$set(el, 'texts', this.txt1[idx])
      })
      // axios({
      //   url: 'https://pc-merge.wenhua.com.cn/wh10/f10/MApi/Note/WDGetFileListNew?IssueName=T10',   // NoteType: 0 全部，1 自定义因子调用，2 Python3调用
      //   method: 'Get'
      // }).then((res)=>{
      //   this.list1=res.data.Data.Children
      //   console.log(this.list1)
      //   this.list1.forEach((el,idx)=>{
      //           this.$set(el, 'texts', this.txt1[idx])
      //   })
      // })
    },
    lianxi(t) {
      this.tt = t;
      this.showcont = true;
      //  var a= document.getElementsByTagName("html")[0]
      var mask_bg = document.createElement("div");
      mask_bg.id = "mask_bg";
      mask_bg.style.position = "fixed";
      mask_bg.style.top = "0px";
      mask_bg.style.left = "0px";
      //  mask_bg.style.right = "0px";
      // mask_bg.style.bottom = "0px";
      mask_bg.style.width = "100%";
      mask_bg.style.height = "100%";
      mask_bg.style.backgroundColor = "#777";
      mask_bg.style.opacity = 0.6;
      mask_bg.style.zIndex = 1111111;
      document.body.appendChild(mask_bg);
      var alertcont = document.createElement("cont");
      mask_bg.appendChild(alertcont);
    },

    huoqusf() {
      axios.get("//wh-api.wenhua.com.cn/api/Roadshow/GetProv").then((res) => {
        if (res.data.status) {
          for (var a = 0; a < res.data.data.length; a++) {
            this.sfli.push(res.data.data[a]);
          }
        }
      });
    },
    sfxl() {
      this.ifla = !this.ifla;
    },
    csxl() {
      this.iflacs = !this.iflacs;
    },
    buystop() {
      this.lianxi("暂未开放购买");
    },
    choose(idx) {
      this.sf = this.sfli[idx].prov;
      this.ind = idx + 1;
      this.csfi = [];
      this.csfi = this.sfli[idx].regions;
    },
    choosecs(idx) {
      this.cs = this.csfi[idx].regioN_NAME;
    },
    tijiao() {
      var name = document.getElementById("names").value;
      var tel = document.getElementById("tel").value;
      var comp = document.getElementById("comp").value;
      if (name == "") {
        this.lianxi("请输入姓名");
        return;
      }
      if (tel == "") {
        this.lianxi("请输入手机号");
        return;
      }
      if (comp == "") {
        this.lianxi("请输入公司名称");
        return;
      }
      if (this.sf == "- 省份 -") {
        this.lianxi("请选择省份");
        return;
      }
      if (this.cs == "- 城市 -") {
        this.lianxi("请选择城市");
        return;
      }
      if (!/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(tel)) {
        this.lianxi("手机号码格式不正确");

        return false;
      }
      console.log(this.sf);
      axios
        .post("//wh-api.wenhua.com.cn/api/Roadshow/CreateRoadshow", {
          name: name,
          phone: tel,
          companyName: comp,
          province: this.ind,
          ProvinceName: this.sf,
          regionName: this.cs,
        })
        .then((res) => {
          if (res.status) {
            this.lianxi("提交成功");
          } else {
            this.lianxi("提交失败，请重试");
          }
        });
    },
    async setCommonData(){
      this.text = await commonData('appShortName_37')
    }
  },
  mounted() {
    this.huoqusf();
    this.getdict()
    this.setPrice()
    window.addEventListener("click", (e) => {
      if (this.$refs.cs && !this.$refs.cs.contains(e.target)) {
        this.iflacs = false;
      }
      if (this.$refs.sf && !this.$refs.sf.contains(e.target)) {
        this.ifla = false;
      }
    });
  },
  created(){
    this.setCommonData()
  }
};
</script>

<style scoped>
.daozhuan{
      transform: rotateX(180deg);
}
.leftyc{
    padding: 21px 0!important;
}
.left {
  text-align: left !important;
  padding-left: 10px !important;
}
.href {
  color: #3888ff;
  /* text-decoration: underline; */
  cursor: pointer;
  font-size: 14px;
  margin-left: 20px;
  vertical-align: middle;
}
.title {
  margin-top: 30px;
  font-size: 18px;
  color: #666;
  /* font-weight: bold; */
}
.buytable thead tr,.buytable2 tr:first-child {
  background: url(../assets/img/table_title.png)no-repeat center;
  background-size: 100% 100%; 
}
.buytable tr {
  /* height: 35px; */
  vertical-align: middle;
  color: #737373;
  font-size: 14px;
}
.buytable td {
  padding-left: 50px;
  vertical-align: middle;
  color: #737373;
}

.buytable2 td{
  line-height: 20px;
  padding: 8px 0;
  text-align: center !important;
  padding-right: 0 !important;
}

.lightTr {
  background: #f7f7f7;
}
.buytable thead tr:first-child {
  /* height: 40px;
  line-height: 40px; */
  /* background: #c75438; */
  text-align: center;
  color: #fff;
  font-size: 16px;
  /* font-weight: bold; */
}
.buytable thead tr:first-child td {

  padding: 7px 0 !important;
}
.buytable2 tr:first-child {
  /* height: 40px;
  line-height: 40px; */
  /* background: #c75438; */
  text-align: center;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
}
.buytable tr:first-child td {
  padding-left: 0;
  color: inherit;
}
.buytable tr td:nth-last-child(3) {
  /* background: #fef7fa; */
  text-align: center;
  padding:8px 10px;
}
.buytable tr td:nth-last-child(2) {
  /* background: #fef7fa; */
  text-align: justify;
  padding:8px 10px;
}
.buytable tr td:nth-last-child(1) {
  /* background: #fffff9; */
  text-align: center;
  padding: 8px 0;
}
/* .buytable tr td:nth-last-child(2) {
  text-align: center;
  padding-left: 0;
} */
/* .buytable tr td:nth-last-child(1) {
  text-align: center;
  padding-left: 0;
} */
.firstline td:first-child {
  text-align: center;
  padding: 0 ;
}
/*.firstline td:nth-child(2){
  background: none  !important;
}
.firstline td:nth-child(3){
  background: #fef7fa !important;
}
.firstline td:nth-child(4){
  background: #fffff9;
} */
.col td {
  background: white !important;
  text-align: left !important;
  padding-left: 50px !important;
}
.col td:last-child {
  padding-left: 90px !important;
}
#buy {
  position: relative;
  color: #7b7b7b;
}

.buy_container {
  width: 1050px;
  height: 100%;
  position: relative;
  margin: -252px auto 0 auto;

  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 0 20px -5px #ccc;
}
.buy_containers {
  padding: 30px 30px 30px 30px;
}
.buy_title {
  font-size: 22px;
  line-height: 40px;
  border-bottom: 1px dashed #a8a8a8;
}

.buy_detail {
  position: relative;
  min-height: 460px;
  /* width: 840px; */
  width: 100%;
  margin: 0 auto;
}

.contactUs {
  height: 47px;
  line-height: 47px;
  width: 198px;
  text-align: center;
  background-color: #287cee;
  color: #fff;
  border-radius: 23px;
  margin: 102px auto 0 auto;
}

.yuyue {
  /* height: 330px; */
  background: #f5f8ff;
  padding: 20px 125px;
  margin-bottom: 10px;
  width: 500px;
  font-size: 14px;
}
.yuyue input {
  margin: 10px 0;
}
.yuyue h3 {
  text-align: center;

  font-size: 20px;
  line-height: 25px;
  color: #7f8080;
  padding-top: 15px;
}
.yuyue p {
  font-size: 16px;
  line-height: 30px;
  color: #5574a3;
  margin-bottom: 15px;
}
.yuyue input {
  height: 30px;
  background: white;
  box-shadow: 0 0 20px -5px #ccc;
  padding-left: 10px;
  outline: none;
  border: none;
  font-size: 16px;
  width: 320px;
}
.yuyue h4 {
  width: 85px;
  letter-spacing: 5px;
  line-height: 40px;
  height: 40px;
  margin-left: 10px;
  display: inline-block;
  text-align: right;
  padding-right: 8px;
  color: #808080;
}
.shengfen {
  width: 140px;
  display: inline-block;
  height: 30px;
  background: white;
  box-shadow: 0 0 20px -5px #ccc;
  line-height: 30px;
  padding-left: 10px;
  letter-spacing: 2px;
}
.selectt {
  width: 30px;
  height: 30px;
  background: url(../assets/img/xia.png) no-repeat;
  color: white;
  float: right;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
}
.xiala {
  width: 150px;
  float: right;
  background: white;
  box-shadow: 0 0 20px -5px #ccc;
  height: 100px;
  overflow-y: scroll;
}
.xiala li {
  width: 100%;
  height: 20px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
  overflow: hidden;
}
.xiala li:hover {
  background: #f5f8ff;
}
.sub {
  width: 100px;
  background: #3c77f7;
  border-radius: 10px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  margin: 0 auto;
  color: white;
  margin-top: 15px;
  cursor: pointer;
}
/* input:-internal-autofill-selected{
    background: white;
  } */
input:-internal-autofill-selected {
  background: black;
}
.buytable td {
  border: 1px solid #cccccc;
  /* border-bottom: 1px solid #bcbaba; */
}
.buytable thead td {
  border: 1px solid white;
}
.buytable img {
  position: absolute;
  /* margin-left: 6px; */
  margin-bottom: 4px;
}
.zhu {
  background: #a7152e;
  margin-top: 20px;
  color: white;
  padding-left: 7px;
  height: 25px;
  line-height: 25px;
  font-size: 14px;
  width: 50px;
  border-radius: 0 20px 20px 0;
}
.zhushi {
  line-height: 24px;
  font-size: 14px;
  color: #666;
  letter-spacing: 1px;
  /* text-indent: 2em; */
  /* padding-left: 37px; */
}
.zhushia {
  /* padding-left: 15px; */
}

.num_text {
  color: #287cee;
  font-size: 16px;
  /* margin-left: 20px; */
}
.txt_l {
  height: 29px;
  line-height: 29px;
}
.yuanchaung{
  position: absolute;
  top: -14px;
  left: -15px;
  /* width: 24px; */
}
.jiabcen{
  padding: 10px 0;
  text-align: center;
  padding-left: 0 !important;
}
.tipsss{
  border:1px solid #cccccc;
  border-top:none;
  padding: 20px;
}
.tdstyle1{
  text-align: left  !important;
  padding: 4px 8px!important;
}
</style>